<template>
    <div class="app">
        <div class="bg"></div>
        <div class="head">
            <div class="logo"></div>
            <div class="line"></div>
            <div class="icon" :style="'background-image:url(' + projectIcon + ')'"></div>
            <div class="name">{{ projectName }}</div>
        </div>
        <div class="basicInfo">
            <div class="tem">
                <div>{{ weather }}</div>
                <div>{{ temperature }}℃</div>
            </div>
            <div class="hum">
                <div>湿度:</div>
                <div>{{ humidity }}%</div>
            </div>
        </div>
        <div class="time">{{ time }}</div>
        <router-view :key="$route.name + ($route.params.id || '')"></router-view>
    </div>
</template>

<script>
    import {
        GetBaseInfo
    } from "../components/Request";

    export default {
        name: "App",
        data() {
            return {
                weather: "",
                temperature: "--",
                humidity: "--",
                time: "",
                projectName: "",
                projectIcon: ""
            };
        },
        mounted() {
            // 区域总览信息
            GetBaseInfo({
                projectId: this.$store.state.projectId
            }).then(({
                data
            }) => {
                this.$store.commit("set_val", {
                    receivingCapacity: JSON.parse(data.data.project.projectDetailsInfo)['受电容量'],
                    voltageClass: JSON.parse(data.data.project.projectDetailsInfo)['供电电压']
                });
                this.projectName = data.data.project.projectName
                this.projectIcon = data.data.project.projectIcon
            })

            // 动态时间显示
            setInterval(() => {
                this.time = this.dateFormat("YYYY.mm.dd HH:MM:SS", new Date());
            }, 1000);

            this.getWeatherInfo()

            setInterval(() => {
                this.getWeatherInfo()
            }, 30 * 60 * 1000);

        },
        methods: {
            dateFormat(fmt, date) {
                let ret;
                const opt = {
                    "Y+": date.getFullYear().toString(), // 年
                    "m+": (date.getMonth() + 1).toString(), // 月
                    "d+": date.getDate().toString(), // 日
                    "H+": date.getHours().toString(), // 时
                    "M+": date.getMinutes().toString(), // 分
                    "S+": date.getSeconds().toString(), // 秒
                    // 有其他格式化字符需求可以继续添加，必须转化成字符串
                };
                for (let k in opt) {
                    ret = new RegExp("(" + k + ")").exec(fmt);
                    if (ret) {
                        fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0"));
                    }
                }
                return fmt;
            },

            getWeatherInfo() {
                // 天气信息
                fetch("https://restapi.amap.com/v3/weather/weatherInfo?city=" + 420114 +
                        "&key=3ecd07184027ff3342dc5f24551c2ecc")
                    .then((response) => response.json())
                    .then((json) => {
                        const {
                            temperature,
                            weather,
                            humidity
                        } = json.lives[0];
                        this.temperature = temperature;
                        this.weather = weather;
                        this.humidity = humidity;
                    }).catch((e) => {
                        return e;
                    });
            }
        },
    };
</script>

<style lang="less" scoped>
    .app {
        margin: 0;
        padding: 0;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
    }

    .bg {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-image: url("../assets/img/bg.png");
        background-size: 100% 100%;
        clip-path: polygon(0 0, 100% 0, 100% 22%, 12% 22%, 12% 78%, 88% 78%, 88% 22%, 100% 22%, 100% 100%, 0 100%, 0 0);
        z-index: 0;
    }

    .head {
        width: 6300/192vw;
        height: 720/108vh;
        display: flex;
        flex-direction: row;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
    }

    .logo {
        width: 1080/192vw;
        height: 340/108vh;
        margin-left: 160/192vw;
        background-image: url("../assets/img/logo.png");
        background-size: 100% 100%;
    }

    .line {
        width: 20/192vw;
        height: 330/108vh;
        margin-left: 200/192vw;
        background: rgba(255, 255, 255, 0.3);
    }

    .icon {
        width: 300/192vw;
        height: 340/108vh;
        margin-left: 200/192vw;
        background-color: #fff;
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }

    .name {
        font-family: YouSheBiaoTiHei;
        color: #e6f3fd;
        font-size: 360/192vw;
        margin-left: 110/192vw;
    }

    .basicInfo {
        width: 2710/192vw;
        height: 160/108vh;
        position: fixed;
        top: 340/108vh;
        right: 470/192vw;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-family: YouSheBiaoTiHei;
        font-size: 220/192vw;
        color: #e6f3fdff;
    }

    .tem,
    .hum {
        width: 1200/192vw;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
    }

    .time {
        width: 1830/192vw;
        height: 110/108vh;
        position: fixed;
        left: 8680/192vw;
        top: 900/108vh;
        font-family: YouSheBiaoTiHei;
        font-size: 180/192vw;
        color: #e6f3fdff;
        white-space: nowrap;
    }
</style>